<template>
    <div class="full_body">
        <div class="main_content">
            <div class="box">
                <div class="tip">您的密码是初始密码，为了您的账号安全，请您修改密码！</div>
                <el-form :model="form" ref="form" label-width="80px" :rules="rules">
                    <el-form-item label="原密码" prop="oldPwd">
                        <el-input autocomplete="off"  type="password" show-password placeholder="请输入原密码" v-model.trim="form.oldPwd" ></el-input>
                    </el-form-item>
                    <el-form-item 
                        label="新密码"
                        prop="newPwd"
                    >
                        <el-input autocomplete="off"  type="password" show-password placeholder="密码格式为由大写字母开头,大小写字母、数字、特殊字符中的至少3种组成8~30位的字符串" v-model.trim="form.newPwd"></el-input>
                    </el-form-item>
                    <el-form-item 
                        label="确认密码"
                        prop="newPwd2"
                    >
                        <el-input autocomplete="off"  type="password" show-password placeholder="请再次确认密码" v-model.trim="form.newPwd2"></el-input>
                    </el-form-item>
                    <div class="t_center" style="margin-top:30px;">
                        <el-button type="danger" @click="save">保存</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import Md5 from "js-md5"
export default {
    name: '',
    data() {
        return {
            form:{},
            rules:{
                oldPwd:[{ required: true, message: '原密码不能为空', trigger: 'blur' }],
                newPwd:[
                    { required: true, message: '新密码不能为空', trigger: 'blur' },
                    { required: true,pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[A-Z]{1}[a-zA-Z0-9\W_]{7,29}$/,message: '密码格式为由大写字母开头,大小写字母、数字、特殊字符中的至少3种组成8~30位的字符串',trigger: 'blur'}
                ],
                newPwd2:[{ required: true, message: '确认密码不能为空', trigger: 'blur' }]
            }
        }
    },
    methods: {
        save(){
            this.$refs['form'].validate((valid) => {
                if(valid){
                    if(this.form.newPwd != this.form.newPwd2){
                        this.$tip.error("两次密码输入不一致，请确认密码");
                    }else{
                        let data = {
                            oldPwd:Md5(this.form.oldPwd),
                            newPwd:Md5(this.form.newPwd)
                        }
						this.$store.dispatch("mine/updatePassword", data).then(res=>{
							this.$tip.success(res.msg,1,() => {
								this.$router.push("/sign/in")
							})
						})
                    }
                }
            });
        }
    },
}
</script>
<style lang='scss' scoped>
.main_content{top:60px;}
.box{background:#fff;    width: 750px;    padding: 40px;    margin: 100px auto;}
.tip{background: #f1f1f1;
    margin: -40px -40px 46px;
    color: #f40;
    padding: 20px;
    font-size: 18px;}
</style>